var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 51,
    viewBox: "0 0 57 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5002 10.0772L22.3746 35.2056L9.49683 22.3278C8.71578 21.5468 7.44945 21.5468 6.6684 22.3278L2.58579 26.4104C2.21071 26.7855 2 27.2942 2 27.8246C2 28.3551 2.21071 28.8638 2.58579 29.2389L20.9604 47.6135C21.7415 48.3945 23.0078 48.3945 23.7889 47.6135L54.4142 16.9881C54.7894 16.613 55.0001 16.1041 55 15.5736C54.9999 15.043 54.789 14.5342 54.4137 14.1592L50.3282 10.0766C49.5471 9.296 48.2811 9.29626 47.5002 10.0772Z",
    fill: "#26266C",
    fillOpacity: 0.7,
    stroke: "#26266C",
    strokeOpacity: 0.7,
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5002 2.58586L22.3746 27.7142L9.49683 14.8365C8.71578 14.0555 7.44945 14.0555 6.6684 14.8365L2.58579 18.9191C2.21071 19.2942 2 19.8029 2 20.3333C2 20.8638 2.21071 21.3725 2.58579 21.7475L20.9604 40.1222C21.7415 40.9032 23.0078 40.9032 23.7889 40.1222L54.4142 9.49682C54.7894 9.12167 55.0001 8.61281 55 8.08226C54.9999 7.5517 54.789 7.04292 54.4137 6.6679L50.3282 2.58529C49.5471 1.80468 48.2811 1.80494 47.5002 2.58586Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckShadow);
export default __webpack_public_path__ + "static/media/check-shadow.658062d7c7839130d1f9c848af28f8bd.svg";
export { ForwardRef as ReactComponent };